import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {
  MarketFormulaJS,
  TransactionType,
  marketFormulaDefaultCollateralDebtPosition,
  marketFormulaDefaultLiquidationRatio,
  necessaryAmountForLandTokenRent,
  necessaryLandTokenForStableTokenRent,
} from '@shareland/shareland-common';
import {useContext} from 'react';

export const useActionMenuTokenInputConvertAmountToOpposite = (
  transactionType: TransactionType.Purchase | TransactionType.Sell | TransactionType.MintLiquidityToken,
) => {
  const {landMarketInfo} = useContext(ActionMenuContext);

  return {
    [TransactionType.Purchase]: {
      stable: (amount: number) => {
        const transaction = MarketFormulaJS.purchaseStableTokenTransaction(
          amount,
          landMarketInfo.availableSupply,
          landMarketInfo.totalLiquidity,
          landMarketInfo.oraclePrice,
          landMarketInfo.marketFormulaWeigths,
          marketFormulaDefaultLiquidationRatio,
        );

        return transaction.landTokenAmount + transaction.collateralLandTokenAmount;
      },
      land: (amount: number) => {
        const transaction = MarketFormulaJS.purchaseLandTokenTransaction(
          amount,
          landMarketInfo.availableSupply,
          landMarketInfo.totalLiquidity,
          landMarketInfo.oraclePrice,
          landMarketInfo.marketFormulaWeigths,
          marketFormulaDefaultLiquidationRatio,
        );

        return transaction.stableTokenAmount + transaction.collateralStableTokenAmount;
      },
    },
    [TransactionType.Sell]: {
      stable: (amount: number) => {
        const result = MarketFormulaJS.sellStableTokenAmountTransaction(
          amount,
          landMarketInfo.availableSupply,
          landMarketInfo.totalLiquidity,
          landMarketInfo.oraclePrice,
          landMarketInfo.marketFormulaWeigths,
          marketFormulaDefaultLiquidationRatio,
          marketFormulaDefaultCollateralDebtPosition,
        );

        return result.landTokenAmount + result.collateralLandTokenAmount;
      },
      land: (amount: number) => {
        const result = MarketFormulaJS.sellLandTokenTransaction(
          amount,
          landMarketInfo.availableSupply,
          landMarketInfo.totalLiquidity,
          landMarketInfo.oraclePrice,
          landMarketInfo.marketFormulaWeigths,
          marketFormulaDefaultLiquidationRatio,
          marketFormulaDefaultCollateralDebtPosition,
        );

        return result.stableTokenAmount + result.collateralStableTokenAmount;
      },
    },
    [TransactionType.MintLiquidityToken]: {
      stable: (amount: number) => {
        return necessaryLandTokenForStableTokenRent(landMarketInfo.marketPrice, amount);
      },
      land: (amount: number) => {
        return necessaryAmountForLandTokenRent(landMarketInfo.marketPrice, amount);
      },
    },
  }[transactionType];
};
